import { literal, type, union } from "superstruct";

const TikTokDisplaySettinsSchema = type({
    sortBy: union([literal("newest_first"), literal("tagged_first")]),
});

export default TikTokDisplaySettinsSchema;
